import { env } from './helpers/environment';

const dev = {
  southVanHost: 'http://localhost:8009',
  southVanLogin: 'http://localhost:8009/login'
};

const test = {
  southVanHost: 'https://test.southvanmed.com',
  southVanLogin: 'https://test.southvanmed.com/login'
};

const prod = {
  southVanHost: 'https://southvanmed.com',
  southVanLogin: 'https://southvanmed.com/login'
};

const config = {
  dev,
  test,
  prod
};

export default config[env()];
